module.exports = __webpack_public_path__ + "img/beer_id-6.ce3ee13e.jpg";